module.exports = __webpack_public_path__ + "img/avatar2.4a47c76f.png";